import React, { useState } from 'react';
import { toast } from 'react-toastify';

const ReviewComment = ({ reviewId, onCommentAdded }) => {
  const [comment, setComment] = useState('');
  const [rating, setRating] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [charCount, setCharCount] = useState(0);
  const MAX_COMMENT_LENGTH = 800;

  const handleCommentChange = (e) => {
    const value = e.target.value;
    if (value.length <= MAX_COMMENT_LENGTH) {
      setComment(value);
      setCharCount(value.length);
    }
  };

  const handleStarClick = (selectedRating) => {
    setRating(selectedRating);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!comment.trim()) {
      setError('Bitte geben Sie einen Kommentar ein.');
      return;
    }
    
    if (rating === 0) {
      setError('Bitte wählen Sie eine Bewertung aus.');
      return;
    }
    
    setSubmitting(true);
    setError(null);
    
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Sie müssen angemeldet sein, um zu kommentieren.');
      }
      
      const response = await fetch(`/api/reviews/${reviewId}/comments`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          comment,
          rating
        })
      });
      
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Fehler beim Speichern des Kommentars.');
      }
      
      const data = await response.json();
      
      setComment('');
      setRating(0);
      setCharCount(0);
      
      if (onCommentAdded) {
        onCommentAdded(data);
      }
      
      toast.success('Kommentar erfolgreich hinzugefügt!');
    } catch (err) {
      setError(err.message);
      toast.error(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="review-comment-form">
      <h4>Kommentar hinzufügen</h4>
      
      {error && (
        <div className="error-message">
          <span className="material-symbols-outlined">error</span>
          <p>{error}</p>
        </div>
      )}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group rating-group">
          <label>Bewertung <span className="required">*</span></label>
          <div className="stars-container">
            {[1, 2, 3, 4, 5].map(star => (
              <span
                key={star}
                className={`star material-symbols-outlined ${rating >= star ? 'filled' : ''}`}
                onClick={() => handleStarClick(star)}
              >
                star
              </span>
            ))}
          </div>
        </div>
        
        <div className="form-group">
          <label>
            Kommentar
            <span className={`char-count ${charCount === MAX_COMMENT_LENGTH ? 'char-count-limit' : ''}`}>
              {charCount}/{MAX_COMMENT_LENGTH}
            </span>
          </label>
          <textarea
            value={comment}
            onChange={handleCommentChange}
            placeholder="Schreiben Sie Ihren Kommentar..."
            rows="4"
            required
          />
          {charCount === MAX_COMMENT_LENGTH && (
            <div className="char-limit-warning">
              Sie haben das Zeichenlimit erreicht.
            </div>
          )}
        </div>
        
        <button 
          type="submit" 
          className="submit-button comment-submit" 
          disabled={submitting}
        >
          {submitting ? (
            <>
              <div className="loading-spinner small"></div>
              <span>Wird gesendet...</span>
            </>
          ) : (
            <>
              <span className="material-symbols-outlined">send</span>
              Kommentar absenden
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default ReviewComment;